import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { UserCreateComponent } from '../user-create/user-create.component';

@Component({
  selector: 'app-server-create',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./server-create.component.scss']
})
export class ServerCreateComponent extends UserCreateComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.subentityName = 'server';
  }

  getMeta(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const meta = await super.getMeta();
      if (!this.isEdit) {
        const next = await this.service.apiCall('api/user/getNextUsername', { service_type: this.subentityName }).toPromise();
        meta.fields.find(f => f.name === 'username').value = next.name;
        resolve(meta);
      } else {
        resolve(meta);
      }
    });
  }
}
